<template>
  <div>
    <ul class="status">
      <li>
        <button
          @click="showModal('product')"
          class="btn btn-sm btn-info mr-1 mb-2"
        >
          <span class="ti-plus"></span> Товар
        </button>
      </li>
      <li>
        <button
          @click="refresh"
          class="btn btn-sm btn-warnign mr-2 mb-2"
        >
          <span class="ti-reload"></span>  
        </button>
      </li>
    </ul>
    <ul class="body_content">
      <li v-for="item in items" :key="item.id">
        <div class="purchase_info">
          <div>
            <img :src="item.image" :alt="item.display_name" />
          </div>
          <div>
            <div>{{ item.display_name }}</div>
            <div v-if=" item.business">Бизнес: {{ item.business.name }} <span class="text-warning" v-if="item.is_confirm">  - подтвержден</span></div>
            <h4 @click="copy(item.sku)">{{ item.sku }}</h4>
            <div>{{ item.price*item.quantity | spaceBetweenNumber }} сум</div>
            <p>{{item.title}}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 col-lg-4">
            <fg-input
              type="number"
              :label="'Количество'"
              v-model="item.quantity"
            ></fg-input>
        </div>
        <div class="col-12 col-md-6 col-lg-4">
           <fg-input
              type="number"
              :label="'Цена'"
              v-model="item.price"
            ></fg-input></div>
          <div class="col-12">
            <button @click="saveItem(item)" class="btn btn-sm btn-success mr-2">
              <span class="ti-save"></span>
            </button>
            <button @click="removeItem(item)" class="btn btn-sm btn-danger">
              <span class="ti-trash"></span>
            </button>
          </div>
        </div>
      </li>
    </ul>
    <list-item
      v-if="modal"
      :modal="modal"
      v-model="selectData[modal]"
      :simple="true"
      @input="push"
    />
  </div>
</template>

<script>
import { cardUpdate, cardContent } from "../../../plugins/functions";

export default {
  components: {
    "list-item": () => import("../../Modals/ListItem"),
    "sub-field-list": () => import("../SubFieldList"),
  },
  data: () => ({
    cardLink: "orders/purchase",
    cardPushLink: "orders/push",
    cardRejectLink: "orders/reject",
    showCreate: false,
    items: [],
    modal: "",
    selectData: {},
  }),
  props: ["id"],
   created() {
     this.refresh();
  },
  methods: {
    cardContent: cardContent,
    cardUpdate: cardUpdate,
    async refresh(){
      this.items = await this.cardContent(this.cardLink, this.id, "list");
    },
    copy(val) {

    },
    async push(val, isNew = true) {
      let item = {};
      if (isNew === true) {
        if (!val[0]) {
          return false;
        }
        item = val[0];
      } else {
        item = val;
      }

        if (isNew === true) {
            item['quantity'] = 1;
        }

      let newItem = await this.cardUpdate(
        `${this.cardPushLink}?id=${this.id}`,
        { object: item },
        "post"
      );
      if (isNew === true) {

        let isPush = true;

        for(let i = 0; i<this.items.length;i++){
            if (this.items[i].sku === newItem.sku) {
                isPush = false;
            }
        }
        if (isPush === true){
              this.items.push(newItem);
        }

        this.modal = "";
        this.selectData = {};
      }
    },
    showModal(modal) {
      this.selectData[modal] = [];
      this.modal = modal;
      setTimeout(() => {
        this.$modal.show(this.modal);
      }, 10);
    },
    saveItem(item) {
      this.push(item, false);
    },
    removeItem(item) {
      if (
        this.cardUpdate(
          `${this.cardRejectLink}?id=${this.id}`,
          { object: item },
          `delete`
        )
      ) {
        for (let i = 0; i < this.items.length; i++) {
          if (item.id === this.items[i].id) {
            this.items.splice(i, 1);
            break;
          }
        }
      }
    },
  },
};
</script>
<style lang="scss">
ul.body_content {
  list-style: none;
  margin: 0;
  padding: 0;
  & > li {
    background: #f2f2f2;
    border-radius: 10px;
    margin-bottom: 20px;
    padding: 15px;
    & > .purchase_info {
      margin-bottom: 10px;
      display: flex;
      & > div {
        & > div {
          font-weight: bold;
          & > div:first-child {
            font-size: 18px;
          }
        }
        &:first-child {
          width: 90px;
        }
        &:last-child {
          width: calc(100% - 90px);
        }
        & img {
          height: 70px;
          width: 70px;
          object-fit: contain;
        }
      }
    }
  }
}

.ql-editor {
  background: #fff;
}
</style>
